import { Box } from "@mui/material";
import Link from "next/link";
import { useUsersByWallet } from "~/features/users";
import { fontFamilies, colors } from "~/theme";

interface ArtworkOwnerProps {
    ownedByYou: boolean;
    ownerWallet: string;
}

export function ArtworkOwner({ ownedByYou, ownerWallet }: ArtworkOwnerProps) {
    const usersByWallet = useUsersByWallet();

    if (ownedByYou) {
        return (
            <Box
                component="span"
                fontFamily={fontFamilies.poppins}
                marginRight="10px"
                data-testid="token-owned-by-you"
            >
                <Box
                    component="span"
                    sx={{
                        textDecoration: "underline",
                        color: colors.linkPink,
                    }}
                >
                    You
                </Box>
            </Box>
        );
    }

    return (
        <Box
            component="span"
            sx={{
                textDecoration: "underline",
                color: colors.linkPink,
            }}
        >
            {usersByWallet[ownerWallet!]?.id ? (
                <Link
                    data-testid="owned-by-link"
                    href={`/profile/${usersByWallet[ownerWallet!]?.id}${
                        globalThis?.window?.location?.search
                    }`}
                    passHref
                >
                    <a
                        href={`/profile/${usersByWallet[ownerWallet!]?.id}${
                            globalThis?.window?.location?.search
                        }`}
                    >
                        @
                        <span hidden={!!usersByWallet[ownerWallet!]?.nickname}>
                            {`${ownerWallet!.slice(
                                0,
                                6,
                            )}...${ownerWallet!.slice(-6)}`}
                        </span>
                        <span hidden={!usersByWallet[ownerWallet!]?.nickname}>
                            {usersByWallet[ownerWallet!]?.nickname}
                        </span>
                    </a>
                </Link>
            ) : (
                <>
                    <span hidden={!!usersByWallet[ownerWallet!]?.nickname}>
                        {`${ownerWallet!.slice(0, 6)}...${ownerWallet!.slice(
                            -6,
                        )}`}
                    </span>
                    <span hidden={!usersByWallet[ownerWallet!]?.nickname}>
                        {usersByWallet[ownerWallet!]?.nickname}
                    </span>
                </>
            )}
        </Box>
    );

    return null;
}
